import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  banners: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedVipBanner: null,
};

/* ================== THUNKS ================== */

export const fetchVipBanners = createAsyncThunk(
  'banners/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/banners', {
          params: { fetchType, page, limit, search }
        });
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createVipBanner = createAsyncThunk(
  'banners/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/banners', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchVipBannerById = createAsyncThunk(
  'banners/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/banners/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateVipBanner = createAsyncThunk(
  'banners/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/banners/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const deleteVipBanner = createAsyncThunk(
  'banners/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/banners/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const toggleVipBannerStatus = createAsyncThunk(
  'banners/toggle-status',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/api/admin/banners/${id}/toggle-status`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);


/* ================== SLICE ================== */

const vipBannerSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchVipBanners.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchVipBanners.fulfilled, (state, action) => {
            const { data, pagination } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.banners = data;
        })
        .addCase(fetchVipBanners.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(fetchVipBannerById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedVipBanner = action.payload;
        })
        .addCase(fetchVipBannerById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        /* UPDATE */
        .addCase(updateVipBanner.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updateVipBanner.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(toggleVipBannerStatus.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload?.data;
            if (updated) {
                state.banners = state.banners.map((c) =>
                    c.id === updated.id ? updated : c
                );

                state.selectedVipBanner = updated;
            }
        })
       
      /* DELETE */
      .addCase(deleteVipBanner.fulfilled, (state, action) => {
        state.banners = state.banners.filter((p) => p._id !== action.payload);
      });
  }
});

export default vipBannerSlice.reducer;